export default __webpack_public_path__ + "static/media/Vector.931552b4.svg";